import React from 'react';
import Button, { Themes } from 'ui/Button/Button';

import styles from './RecallButton.module.css';

import recall from 'assets/icons/recall.png';

interface IApproveSection {
  onClickRecall: () => void;
}

const RecallRequest = ({ onClickRecall }: IApproveSection) => (
  <div className={styles.container}>
    <Button theme={Themes.secondary} type="button" className={styles.btn} onClick={onClickRecall}>
      <div className={styles.btnIconWrapper}>
        <img src={recall} alt="recall_request_icon" />
      </div>
      Recall Request
    </Button>
  </div>
);

export default RecallRequest;
